import styled from "styled-components";
import { PanelContainer } from "../../styled/common";

export const BookinPanelContainer = styled(PanelContainer)`
  padding: 28px 27px 50px;
`;

export const BookingDates = styled.div`
  width: 70%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
`;
export const DateTitle = styled.span`
  font-size: 15px;
`;

export const Dates = styled.span`
  font-size: 15px;
  font-family: Poppins-SemiBold;
`;
export const CapitalizeString = styled.span`
  text-transform: capitalize;
`;

export const BookingTimes = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 35px;
  border-bottom: 1px solid #dee2db;
`;

export const FieldWrapper = styled.div`
  width: 48%;
`;

export const ConfirmButtonContainer = styled.div`
  margin-top: 33px;
`
